export function Skeleton() {
	return (<>
	<div role="status" class="max-w-sm animate-pulse">
		<div class="h-2.5 bg-gray-300 rounded-full w-48 mb-4"></div>
		<div class="h-2 bg-gray-300 rounded-full max-w-[360px] mb-2.5"></div>
		<div class="h-2 bg-gray-300 rounded-full mb-2.5"></div>
		<div class="h-2 bg-gray-300 rounded-full max-w-[330px] mb-2.5"></div>
		<div class="h-2 bg-gray-300 rounded-full max-w-[300px] mb-2.5"></div>
		<div class="h-2 bg-gray-300 rounded-full max-w-[360px]"></div>
		<span class="sr-only">Loading...</span>
	</div>
	</>);
  }